<template>
  <div class="AssemblyTableComponent DataTables">
    
    <div v-show="isData" :id="id"></div>

    <LoaderComponent  v-if="!isData"></LoaderComponent>
    <!-- <ContextMenuComponent :menu="menu"  :id="name"></ContextMenuComponent> -->
  </div>
    
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'AssemblyTableComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    // ContextMenuComponent

  },
  data () {
      return {
        name: 'AssemblyTableComponent',
        mainTable: "",
        id: "tableplace_"+this._uid,
        columns: [],
        colsAssign: [],
        parts: [],
        isData: false,
        // contextMenu: {},
        // //list of items in the context menu
        // menu: [
        //   {id: "Open", text: this.lang.contextmenu_text_Open},
        //   {id: "NewRevision", text: this.lang.contextmenu_text_NewRevision},
        //   {id: "Delete", text: this.lang.contextmenu_text_Delete},
        // ],

      }
  },
  computed: {
      

    
    categoryId(){
        return this.$store.getters.selectedTreeProjectItemObject.categoryId;
    },
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    }

  },
  created () {

    this.createProjectsTable();


  },
  watch: {
    categoryId: function (newVal, oldVal) {

      console.log("reload")
      this.createProjectsTable();

    },
    reloadedAfterAction: function(newValue, oldValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
            
            this.createProjectsTable();
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  updated() {



  },
  mounted: function () {

  },
  methods: {
    createProjectsTable(){
      let vue = this;

             

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getAssemblies")
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.parts = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "AssemblyId",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_PartNumber,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_ElectricalPartNumber,
          alignInColumn: "left",
          type: "badges"
        },
        
      ]

      this.colsAssign =  [
        { "data": "revisionId" },
        { "data": "partNumber" },
        { "data": "revision" },
        { "data": "partNumberElectrical"},
        
        
      ]

      this.buildTable();
    },
    buildTable(){
          

          var tableplace = document.getElementById(this.id);

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "place" + this._uid);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }
                // if (meta.col == 3){
                //   let status = "";
                  
                //   if (data == true){
                //     status = "<b-badge class='badge badge-success '>BOM</b-badge>";
                //   }
                //   return status;
                // }
                

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.parts;
          option.myColumnFormats = this.columns;
          option.select = true;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


            
          }
          option.fnDrawCallback = function( oSettings ) {
        
            //_vue.buildContextMenu();
          }


          if ($.fn.dataTable.isDataTable("#place"+this._uid)) {
              this.mainTable.destroy();
              console.log("DESTROY TABLE")
          }

          var _vue = this;

          this.mainTable = $('#place'+this._uid).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

          let _mainTable = this.mainTable;

          this.mainTable
            .on( 'select', function ( e, dt, type, indexes ) {

              var rowData = _mainTable.rows( indexes ).data();
              console.log("select")
              console.log(rowData[0])

              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedAssemblyRow", rowData[0])

            })
            .on( 'deselect', function ( e, dt, type, indexes ) {
              console.log("deselect")
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedAssemblyRow");
            })

            $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e, dt, type, indexes) {
              e.stopPropagation() 
                           
              var data = _mainTable.row( this ).data();
              
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data)
            
           
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.open();
            } );

          //search input change view
          var searchplace = document.getElementById("place"+this._uid + "_filter").firstChild
          
          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")




        },
        buildContextMenu(){
          console.log("buildContextMenu")

          var _vue = this;

          
          //context-menu
          var tableid = $("#place" + this._uid);

          $("#place" + this._uid + " tbody tr")
          .on("contextmenu", function(e) {
            
            let tr = $(this).closest('tr');
            let row = _vue.mainTable.row( tr );

            let data = row.data();

            _vue.contextMenu.row = data

            

            //methods in table component
            //var updateUser = _vue.updateUser;
            //var deleteUser = _vue.deleteUser;

            _vue.contextMenu.funcAction = function(_vue, action){

              //calling component methods depending on the context menu item clicked
              if (action == "Open"){
                
                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
                _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.open();
              }
              if (action == "NewRevision"){
                
                 _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
                 _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
                 _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.newRevision();
              }
              if (action == "Delete"){
                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
                _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent._delete();
              }
                

              return true;
            }

            var height = tableid.height();

            var offsetX = tableid.offset().left;
            var offsetY = tableid.offset().top;


            var top = e.clientY - offsetY + 100;
            var left = e.clientX - offsetX + 10;

            
            $("#context-menu-"+_vue.name).css({
              display: "block",
              top: top,
              left: left
            });
            return false; //blocks default Webbrowser right click menu
          })
          .on("click", function() {
            
            $("context-menu-"+_vue.name).hide();
          });

          $("#context-menu-"+_vue.name + " a").on("click", function() {
            
            $(this)
              .parent()
              .hide();
          });
          document.addEventListener('click', function(e){
            let clickInside = e.target.closest("#context-menu-"+_vue.name);
            
            if(clickInside == null){
              
              let contextMenu = document.getElementById("context-menu-"+_vue.name);
              if (contextMenu != null){

                contextMenu.setAttribute('style', 'display:none');
              }
              
                                  
            }
          });
          //context-menu
        }
        
  }
}
</script>


<style lang="scss">
  .AssemblyTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AssemblyTableComponent.vue